import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateContactList } from 'api';
import { toastEmitter } from 'components/Toast';

export default function useUpdateContactList({
  onSuccessFn = () => null,
  onErrorFn = () => null,
} = {}) {
  const queryclient = useQueryClient();
  const Request = useMutation({
    mutationFn: updateContactList,
    mutationKey: ['updateContactList'],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        onErrorFn();
        return toastEmitter('error', responseData?.error?.message);
      }
      onSuccessFn();
      queryclient.invalidateQueries(['contactLists']);
      toastEmitter('success', responseData?.data?.message);
    },
  });
  return { ...Request };
}
